import type { ThemeTokens, BrandColors } from '@/shared/ui/theme/tokens';
import type { NetworkStatus } from '../hooks/useNetworkStatus';

interface NetworkStatusBadgeProps {
  status: NetworkStatus;
  T: ThemeTokens;
  C: BrandColors;
}

export function NetworkStatusBadge({ status, T, C }: NetworkStatusBadgeProps) {
  const { isOnline, lastOnline } = status;
  const accent = isOnline ? C.success : C.danger;

  const formatLast = (d: Date | null): string => {
    if (!d) return '';
    return d.toLocaleTimeString('es', { hour: '2-digit', minute: '2-digit', hour12: false });
  };

  return (
    <div
      title={
        isOnline
          ? 'Conexión activa'
          : `Sin conexión · última conexión a las ${formatLast(lastOnline)}`
      }
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        color: T.textMuted,
        padding: '4px 10px',
        borderRadius: 999,
        background: T.surfaceBg,
        border: `1px solid ${isOnline ? T.border : `${C.danger}40`}`,
        transition: 'border-color .2s',
      }}
    >
      <span style={{ color: isOnline ? T.textMuted : C.danger, display: 'inline-flex', alignItems: 'center' }}>
        {isOnline ? (
          <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12.55a11 11 0 0 1 14.08 0" />
            <path d="M1.42 9a16 16 0 0 1 21.16 0" />
            <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
            <line x1="12" y1="20" x2="12.01" y2="20" />
          </svg>
        ) : (
          <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="2" y1="2" x2="22" y2="22" />
            <path d="M8.5 16.5a5 5 0 0 1 7 0" />
            <path d="M2 8.82a15 15 0 0 1 4.17-2.65" />
            <path d="M10.66 5c4.01-.36 8.14.9 11.34 3.76" />
            <path d="M16.85 11.25a10 10 0 0 1 2.22 1.68" />
            <path d="M5 12.55a11 11 0 0 1 5.17-2.39" />
            <line x1="12" y1="20" x2="12.01" y2="20" />
          </svg>
        )}
      </span>
      <span style={{ fontSize: 12, fontWeight: 600, color: isOnline ? T.textMuted : C.danger }}>
        {isOnline ? 'En línea' : `Sin conexión · ${formatLast(lastOnline)}`}
      </span>
      <div
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: accent,
          boxShadow: `0 0 5px ${accent}`,
          animation: isOnline ? 'none' : 'pulseRed 1.4s ease-in-out infinite',
        }}
      />
    </div>
  );
}
